<template>
  <div class="product__option product__buy-more-save-more">
    <h2>
      <template v-if="product"> Buy more save more </template>
      <sib-skeleton-loading v-else width="12em"></sib-skeleton-loading>
    </h2>
    <div class="content" v-if="product">
      <template
        v-for="(item, index) of store.shop?.productVolumnDiscount || []"
        :key="index"
      >
        <span>{{ item.key }}</span>
        <span>{{ item.value }}</span>
      </template>
    </div>
    <template v-else>
      <div class="content">
        <sib-skeleton-loading
          :class="['mb-sm', index <= 2 ? 'mt-sm' : '']"
          height="1.5em"
          width="5em"
          v-for="index in 6"
          :key="index"
        ></sib-skeleton-loading>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import useProductStore from '@/store/product'
import useSettingStore from '@/store/setting'
import { computed } from 'vue'

const store = useSettingStore()
const productStore = useProductStore()
const product = computed(() => productStore.product)
</script>

<style lang="scss">
.product__buy-more-save-more {
  .content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-left: 1em;
    border: solid 1px var(--border-color);

    span {
      padding: 0.5em 0;
      border-bottom: solid 1px var(--border-color);

      &:nth-last-child(2),
      &:nth-last-child(1) {
        border-bottom: none;
      }
    }
  }

  @include media-md-up {
    .content {
      border: none;
      grid-template-columns: 100px 1fr;
    }
  }

  @include media-lg-up {
    .content {
      grid-template-columns: 150px 1fr;
    }
  }

  @include media-xl-up {
    .content {
      grid-template-columns: 200px 1fr;
    }
  }
}
</style>
